import { Component, Input } from '@angular/core';

@Component({
  selector: 'ss-empty-state',
  template: `
    <div class="ss-empty-state ss-empty-state--{{ variant }}" role="status">
      <span class="ss-empty-state__icon"><lucide-icon [name]="icon" [size]="24" [strokeWidth]="1.8" aria-hidden="true"></lucide-icon></span>
      <h3>{{ title }}</h3>
      <p *ngIf="description">{{ description }}</p>
      <ng-content></ng-content>
    </div>
  `,
  standalone: false
})
export class EmptyStateComponent {
  @Input() title = 'Nenhum dado encontrado';
  @Input() description = 'Ajuste os filtros para tentar novamente.';
  @Input() variant: 'list' | 'internal' | 'chart' = 'list';
  @Input() icon = 'inbox';
}
